module.exports = __webpack_public_path__ + "img/app_02.3ba4ada5.jpg";